import { DialogType } from '@/enums/dialogType'
import api from '@/services/api'

export default {
    namespaced: true,
    state: {
        seller: {},
        lstSeller: [],
        isUpdate: false,
        shouldReload: false,
        search: "",
        itemsPerPage: 25,
        hasNext: false,
        page: 1,
        totalItems: 0,
        headers: [
            { title: 'Vendedor', key: 'sellerName', align: 'center' }
        ],
    },
    getters: {
        getSeller(state) {
            let seller = { ...state.seller }
            return seller
        }
    },
    mutations: {
        setSeller(state, seller) {
            state.seller = seller
        },
        setLstSeller(state, lstSeller) {
            state.lstSeller = lstSeller
        },
        appendLstSeller(state, items) {
            state.lstSeller = [...state.lstSeller, ...items]
        },
        clearLstSeller(state) {
            state.lstSeller = []
        },
        setPage(state, page) {
            state.page = page
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setTotalItems(state, total) {
            state.totalItems = total
        },
        setShouldReload(state, reload) {
            state.shouldReload = reload
        },
        initForm(state) {
            state.isUpdate = false
            state.seller = {}
            state.search = ''
        },
        setUpdating(state) {
            state.isUpdate = true
        }
    },
    actions: {
        async save({ state, dispatch }) {
            if (state.isUpdate) {
                return await dispatch('update')
            }
            else
                return await dispatch('insert')
        },

        async insert({ getters, dispatch }) {
            await api.post(
                '/Seller/Insert',
                getters.getSeller
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Vendedor salvo'
            }, { root: true })

            return true
        },

        async update({ getters, dispatch }) {
            await api.put(
                '/Seller/Update',
                getters.getSeller
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Vendedor atualizado'
            }, { root: true })

            return true
        },

        async search({ state, commit }, { search, limit = 25, page = 1, reset}) {
            let searchParam = search || state.search
            const response = await api.get(
                `/Seller/Search?search=${searchParam}&limit=${limit}&page=${page}`
            )

            if (reset) {
                commit("setLstSeller", response.data.items)
            } else {
                commit("appendLstSeller", response.data.items)
            }

            commit('setHasNext', response.data.hasNext)
            commit('setTotalItems', response.data.totalCount)
            commit('setPage', page)

            return true
        },

        async find({ commit }, sellerId) {
            const response = await api.get(
                `/Seller/Find/${sellerId}`,
            )
            commit('setSeller', response.data)
            commit('setUpdating')

            return true
        },

        async findAll({ commit }) {
            const response = await api.get(
                `/Seller/FindAll/`,
            )
            commit('setLstSeller', response.data)
            
            return true
        },

        async delete({ getters, dispatch }) {
            await api.delete(
                `/Seller/Delete/${getters.getSeller.sellerId}`,
            )
            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Registro deletado com sucesso!'
            }, { root: true })

            return true
        }
    }
}